(function () {
  if (window.__stickyCollectionDrawerInit) return;
  window.__stickyCollectionDrawerInit = true;

  var OPEN_CLASS = 'sticky-collection--sidebar-open';
  var LOCK_CLASS = 'sticky-collection-sidebar-lock';
  var SEARCH_HIDDEN_CLASS = 'is-search-hidden';

  function rootFrom(el) {
    return el && el.closest && el.closest('[data-sticky-collection]');
  }

  function normalizePath(path) {
    return (path || '').replace(/\/+$/, '') || '/';
  }

  function normalizeSearchText(text) {
    return (text || '').toString().trim().toLowerCase();
  }

  function isStandaloneProductView() {
    return new URLSearchParams(window.location.search).get('product_view') === 'standalone';
  }

  function withStandaloneProductView(href) {
    var url = new URL(href || window.location.pathname, window.location.origin);
    url.searchParams.set('product_view', 'standalone');
    return url.pathname + url.search + url.hash;
  }

  function preserveStandaloneProductView(root) {
    if (!isStandaloneProductView()) return;

    root.querySelectorAll('.sticky-collection__menu-link[href], .sticky-collection__mobile-breadcrumb a[href], [data-sticky-collection-product-link][href]').forEach(function (link) {
      link.setAttribute('href', withStandaloneProductView(link.getAttribute('href')));
    });

    root.querySelectorAll('[data-sticky-collection-search-form]').forEach(function (form) {
      if (form.querySelector('input[name="product_view"]')) return;

      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'product_view';
      input.value = 'standalone';
      form.appendChild(input);
    });
  }

  function formTargetsCurrentPage(form) {
    var action = form.getAttribute('action') || window.location.pathname;
    var actionUrl = new URL(action, window.location.origin);
    return normalizePath(actionUrl.pathname) === normalizePath(window.location.pathname);
  }

  function setSearchUrl(form, query) {
    var url = formTargetsCurrentPage(form)
      ? new URL(window.location.href)
      : new URL(form.getAttribute('action') || window.location.pathname, window.location.origin);

    if (query) {
      url.searchParams.set('q', query);
    } else {
      url.searchParams.delete('q');
    }

    url.searchParams.delete('options[prefix]');
    url.searchParams.delete('type');
    window.history.pushState({}, '', url.pathname + url.search + url.hash);
  }

  function applySearch(root, query) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-sticky-collection-search-item]'));
    if (!items.length) return;

    var standaloneProductView = isStandaloneProductView();
    var searchValue = normalizeSearchText(query);
    var tokens = searchValue.split(/\s+/).filter(Boolean);
    var hasQuery = tokens.length > 0;
    var visibleCount = 0;

    items.forEach(function (item) {
      var hiddenByProductView = standaloneProductView && item.hasAttribute('data-sticky-collection-bundle-card');
      var searchText = normalizeSearchText(item.getAttribute('data-sticky-collection-search-text') || item.textContent);
      var isVisible = !hiddenByProductView && (!hasQuery || tokens.every(function (token) {
        return searchText.indexOf(token) !== -1;
      }));

      item.hidden = hiddenByProductView;
      item.classList.toggle(SEARCH_HIDDEN_CLASS, !isVisible);
      if (isVisible) visibleCount += 1;
    });

    root.querySelectorAll('[data-sticky-collection-search-group]').forEach(function (group) {
      var hiddenByProductView = standaloneProductView && group.hasAttribute('data-sticky-collection-bundle-group');
      var hasVisibleItem = Array.prototype.slice.call(group.querySelectorAll('[data-sticky-collection-search-item]')).some(function (item) {
        return !item.hidden && !item.classList.contains(SEARCH_HIDDEN_CLASS);
      });
      group.hidden = hiddenByProductView || (hasQuery && !hasVisibleItem);
    });

    var empty = root.querySelector('[data-sticky-collection-search-empty]');
    if (empty) {
      var term = empty.querySelector('[data-sticky-collection-search-term]');
      if (term) term.textContent = query || '';
      empty.hidden = !hasQuery || visibleCount > 0;
    }

    root.classList.toggle('sticky-collection--search-active', hasQuery);
  }

  function syncSearchFromUrl(root) {
    var form = root.querySelector('[data-sticky-collection-search-form]');
    if (!form || !formTargetsCurrentPage(form)) return;

    var input = form.querySelector('[data-sticky-collection-search-input]');
    var query = new URLSearchParams(window.location.search).get('q') || '';

    if (input) input.value = query;
    applySearch(root, query);
  }

  function initSearch(root) {
    root.querySelectorAll('[data-sticky-collection-search-form]').forEach(function (form) {
      if (form.dataset.stickyCollectionSearchInit === 'true') return;
      form.dataset.stickyCollectionSearchInit = 'true';

      var input = form.querySelector('[data-sticky-collection-search-input]');

      form.addEventListener('submit', function (e) {
        var query = input ? input.value.trim() : '';

        if (formTargetsCurrentPage(form)) {
          e.preventDefault();
          applySearch(root, query);
          setSearchUrl(form, query);
          if (root.classList.contains(OPEN_CLASS)) {
            setOpen(root, false);
          }
          return;
        }

        if (!query) {
          e.preventDefault();
          var action = form.getAttribute('action') || '/collections/shop-all';
          window.location.href = isStandaloneProductView() ? withStandaloneProductView(action) : action;
        }
      });
    });

    syncSearchFromUrl(root);
  }

  function initSort(root) {
    root.querySelectorAll('[data-sticky-collection-sort]').forEach(function (select) {
      if (select.dataset.stickyCollectionSortInit === 'true') return;
      select.dataset.stickyCollectionSortInit = 'true';

      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        var value = select.value || '';

        if (value) {
          url.searchParams.set('sort_by', value);
        } else {
          url.searchParams.delete('sort_by');
        }

        url.searchParams.delete('page');
        window.location.href = url.pathname + url.search + url.hash;
      });
    });
  }

  function initAllSearches(scope) {
    (scope || document).querySelectorAll('[data-sticky-collection]').forEach(function (root) {
      preserveStandaloneProductView(root);
      initSearch(root);
      initSort(root);
    });
  }

  function setOpen(root, open) {
    if (!root) return;
    root.classList.toggle(OPEN_CLASS, open);
    var btn = root.querySelector('[data-sticky-collection-open]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.classList.toggle(LOCK_CLASS, open);

    var backdrop = root.querySelector('[data-sticky-collection-backdrop]');
    if (backdrop) backdrop.setAttribute('aria-hidden', open ? 'false' : 'true');

    window.requestAnimationFrame(function () {
      if (open) {
        var closeEl = root.querySelector('[data-sticky-collection-close]');
        if (closeEl) closeEl.focus();
      } else if (btn) {
        btn.focus();
      }
    });
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-sticky-collection-open]');
    if (openBtn) {
      e.preventDefault();
      setOpen(rootFrom(openBtn), true);
      return;
    }
    if (e.target.closest('[data-sticky-collection-close]')) {
      e.preventDefault();
      setOpen(rootFrom(e.target), false);
      return;
    }
    if (e.target.closest('[data-sticky-collection-backdrop]')) {
      e.preventDefault();
      setOpen(rootFrom(e.target), false);
      return;
    }
    var navLink = e.target.closest('.sticky-collection__sidebar a[href]');
    var navRoot = rootFrom(navLink);
    if (navLink && navRoot && navRoot.classList.contains(OPEN_CLASS)) {
      setOpen(navRoot, false);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-sticky-collection].' + OPEN_CLASS).forEach(function (root) {
      setOpen(root, false);
    });
  });

  window.addEventListener('resize', function () {
    if (window.matchMedia('(min-width: 990px)').matches) {
      document.querySelectorAll('[data-sticky-collection].' + OPEN_CLASS).forEach(function (root) {
        setOpen(root, false);
      });
    }
  });

  window.addEventListener('popstate', function () {
    document.querySelectorAll('[data-sticky-collection]').forEach(function (root) {
      syncSearchFromUrl(root);
    });
  });

  document.addEventListener('shopify:section:load', function (e) {
    initAllSearches(e.target);
  });

  initAllSearches(document);
})();
